export default "__VITE_ASSET__CEfXCAD0__"